export enum SingleFacilityTabId {
  /** Labelled "Operational" since the ST #174 redesign; the id stays `general`. */
  General = 'general',
  Financial = 'financial',
  LevelsOfCare = 'levels-of-care',
  FloorPlan = 'floor-plan',
  Info = 'info',
}
